'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const DayMapContext = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createContext)(null);
function DayMapProvider({ children, dayMap = {
    variant: 'day'
}, mode = 'single' }) {
    const context = {
        dayMap,
        mode
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DayMapContext.Provider, {
        value: context,
        children: children
    });
}
export { DayMapContext, DayMapProvider };
